import { Box, BoxProps } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
interface CustomSkeletonProps extends BoxProps {
  animationDelay?: string
}

const CustomSkeleton = ({ ...props }: CustomSkeletonProps) => {
  return (
    <Box {...props}>
      <Skeleton
        animation='wave'
        width='100%'
        height='100%'
        variant='text'
        style={{ transform: 'initial' }}
      />
    </Box>
  )
}

const skeletonLength = Array.from({ length: 8 })

const TableSkeleton = () => {
  return (
    <Box width='100%' overflow='auto'>
      <Box
        width='100%'
        overflow='auto'
        display='flex'
        flexDirection='column'
        role='progressbar'
      >
        {skeletonLength.map((_, i) => {
          return (
            <CustomSkeleton
              width='100%'
              height='4.8rem'
              marginTop='0.8rem'
              key={i}
            />
          )
        })}
      </Box>
    </Box>
  )
}

export default TableSkeleton
